import { render } from "./nuevaMetrica.vue?vue&type=template&id=17a86370"
import script from "./nuevaMetrica.vue?vue&type=script&lang=js"
export * from "./nuevaMetrica.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__